import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { b as _extends } from '../_rollupPluginBabelHelpers-05128ded.js';
import React__default from 'react';
import { u as useLongPress } from '../useLongPress-12280c78.js';
import { n as noop } from '../utils-e0c7329c.js';
import '../MediaQueryContext-d6110905.js';
var ReactionButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className,
    width = props.width,
    height = props.height,
    selected = props.selected,
    _props$dataSbId = props.dataSbId,
    dataSbId = _props$dataSbId === void 0 ? '' : _props$dataSbId,
    onClick = props.onClick,
    children = props.children;
  var onClickHandler = useLongPress({
    onLongPress: noop,
    onClick: onClick
  }, {
    shouldPreventDefault: true,
    shouldStopPropagation: true
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ["sendbird-reaction-button".concat(selected ? '--selected' : '')]).join(' '),
    ref: ref,
    role: "button",
    style: {
      width: width,
      height: height
    }
  }, onClickHandler, {
    tabIndex: 0,
    "data-sb-id": dataSbId
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-reaction-button__inner"
  }, children));
});
export { ReactionButton as default };